import { useEffect, useState } from 'react';

export function useMatchMedia(query: string): boolean {
    const getMatch = () =>
        typeof window !== 'undefined' && 'matchMedia' in window ? window.matchMedia(query).matches : false;

    const [matches, setMatches] = useState<boolean>(getMatch);

    useEffect(() => {
        if (typeof window === 'undefined' || !('matchMedia' in window)) return;
        const mql = window.matchMedia(query);

        setMatches(mql.matches);

        const handler = (ev: MediaQueryListEvent | MediaQueryList) => {
            setMatches('matches' in ev ? ev.matches : mql.matches);
        };

        mql.addEventListener('change', handler as EventListener);
        return () => mql.removeEventListener('change', handler as EventListener);
    }, [query]);

    return matches;
}
